import { render, staticRenderFns } from "./VSelectNoPointerScroll.vue?vue&type=template&id=1d0f7667"
import script from "./VSelectNoPointerScroll.vue?vue&type=script&lang=ts"
export * from "./VSelectNoPointerScroll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0f7667')) {
      api.createRecord('1d0f7667', component.options)
    } else {
      api.reload('1d0f7667', component.options)
    }
    module.hot.accept("./VSelectNoPointerScroll.vue?vue&type=template&id=1d0f7667", function () {
      api.rerender('1d0f7667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VSelectNoPointerScroll.vue"
export default component.exports